export default {"src":"/_next/static/media/wallet-metamask.da3e3ed2.svg","height":319,"width":319,"blurWidth":0,"blurHeight":0};